import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import imgModel from "assets/splashpage/vamoneybacksplash2.png";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import styles from "./styles";

const VAPreviewPage = () => {
  const { discoverTab } = useContext(DiscoverViewContext);
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(discoverTab ? "lg" : "md"),
  );
  const location = useLocation();
  const isMediumScreen =
    useMediaQuery(
      discoverTab !== null ? "(max-width:1400px)" : "(max-width:1200px)",
    ) && !isMobileScreen;

  const checkoutVaPage = () => {
    setUpgradeDialogSource(UpgradeDialogSource.va_preview);
    setOpenCheckoutDialog({
      plan: Plans.VA_YEARLY,
      pageSource: location.pathname,
      source: UpgradeDialogSource.va_preview,
    });
  };

  const rightSide = (
    <Grid container item xs md sx={styles.rightSidebar(isMediumScreen)}>
      <Box>
        <Box sx={[styles.chip, { mb: 2 }]}>🔒 Locked feature</Box>

        <Typography variant="h2" sx={styles.header}>
          <Box component="span" sx={styles.mainHeader}>
            Your Virtual Assistant:
          </Box>{" "}
          <br />
          <Box component="span">
            Virtual Assistant Users are{" "}
            <Box component="span" sx={{ color: "#73BD7E" }}>
              33x more likely
            </Box>{" "}
            to land brand deals.
          </Box>
        </Typography>

        <Typography sx={{ fontSize: { xs: 14, md: 20, lg: 22 }, mb: 3 }}>
          👉 We pitch brands for you, follow up and help you negotiate paid
          deals.
        </Typography>
        <Button
          variant="contained"
          sx={{
            px: { xs: 2, md: 4 },
            py: 1.5,
            fontSize: { xs: 12, md: 14 },
            borderRadius: 10,
          }}
          disableElevation
          onClick={checkoutVaPage}
        >
          Upgrade to unlock pitching on autopilot
        </Button>
      </Box>
    </Grid>
  );

  return (
    <Box sx={isMobileScreen ? { p: 3 } : styles.main}>
      <Grid
        gap={2}
        container
        sx={{
          background: "white",
          borderRadius: 4,
          maxWidth: 1200,
        }}
      >
        {isMobileScreen && rightSide}
        {!isMediumScreen && (
          <Grid item xs={12} lg={5} sx={styles.leftSidebar}>
            <Grid
              container
              gap={1}
              item
              xs={12}
              justifyContent={isMobileScreen ? "center" : "flex-start"}
            >
              <Box sx={styles.chip}>
                📩 300+ emails sent for you every month
              </Box>
              <Box sx={styles.chip}>Tier-one customer support</Box>
              <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
                💸 Exclusive Brand Pay Data
              </Box>
            </Grid>

            <Grid container justifyContent={"center"}>
              <Box
                src={imgModel}
                component="img"
                sx={styles.image(discoverTab !== null)}
              ></Box>
            </Grid>
          </Grid>
        )}

        {!isMobileScreen && rightSide}
      </Grid>
    </Box>
  );
};

export default VAPreviewPage;
